import { useState } from 'react';

export const useAccountsSearch = () => {
    const [keyword, setKeyword] = useState('');

    const handleFilterByKeyword = (newKeyword: string) => {
        setKeyword(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};